import initScrollReveal from "./scripts/scrollReveal";
import initPageSignal from "./scripts/pageSignal";
import initCipherPortrait from "./scripts/cipherPortrait";
import { targetElements } from "./data/scrollRevealConfig";

initScrollReveal(targetElements);
initPageSignal();
initCipherPortrait();

// --- Header clock — my local time, ticking. -------------------------------
const clockFormat = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/Istanbul",
  hour12: false,
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
});

const initClock = () => {
  const node = document.getElementById("utcClock");
  if (!node) return;

  const tick = () => {
    node.textContent = clockFormat.format(new Date());
  };

  tick();
  window.setInterval(tick, 1000);
};

initClock();

// --- Featured song ----------------------------------------------------------
const featuredSpotifySong = {
  title: "Somnus - Instrumental Version",
  artist: "Yoko Shimomura",
  url: "https://open.spotify.com/track/7fxzqLLTXObxIoTfI3FA0l?si=ce67f14a2bfd4563",
  cover: "https://image-cdn-fa.spotifycdn.com/image/ab67616d00001e02c1a3d757e86b84a5b7a68481"
};

const renderFeaturedSpotifySong = () => {
  const card = document.getElementById("spotifyCard");
  const coverNode = document.getElementById("spotifyCover");
  const trackNode = document.getElementById("spotifyTrack");
  const artistNode = document.getElementById("spotifyArtist");

  if (!card || !trackNode || !artistNode) return;

  trackNode.textContent = featuredSpotifySong.title;
  artistNode.textContent = featuredSpotifySong.artist;
  card.href = featuredSpotifySong.url;

  if (coverNode) {
    coverNode.src = featuredSpotifySong.cover;
    coverNode.alt = `${featuredSpotifySong.title} cover`;
    coverNode.addEventListener(
      "error",
      () => {
        coverNode.hidden = true;
      },
      { once: true }
    );
  }
};

renderFeaturedSpotifySong();

// --- GTA VI countdown -------------------------------------------------------
const gtaLaunchDate = new Date("2026-11-19T00:00:00-05:00");

const renderGtaCountdown = () => {
  const node = document.getElementById("gtaCountdown");
  if (!node) return;

  const diff = gtaLaunchDate.getTime() - Date.now();

  if (diff <= 0) {
    node.textContent = "It is finally Vice City time.";
    return;
  }

  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);

  node.textContent = `${days}d ${hours}h ${minutes}m`;
};

renderGtaCountdown();
window.setInterval(renderGtaCountdown, 60 * 1000);

// --- YousefGPT — the decorative chat ----------------------------------------
const decorChatReplies = [
  "Message received. A real answer is still better directed to Yousef.",
  "I ran the numbers and concluded that Yousef should answer this one.",
  "That deserves a human reply. Yousef is the useful model here.",
  "Automatic reply complete. For the interesting part, ask Yousef directly."
];

let decorChatUsed = false;
let yousefGptCountry = "";
let countryLookupPromise = null;

const detectDeviceType = () => {
  const ua = navigator.userAgent || "";
  const hasTouch = navigator.maxTouchPoints > 1;

  if (/ipad|tablet|kindle|playbook|silk/i.test(ua)) return "Tablet";
  if (/mobi|iphone|ipod|android.*mobile|windows phone/i.test(ua)) return "Phone";
  if (hasTouch && Math.min(window.innerWidth, window.innerHeight) >= 700) return "Tablet";
  return "Desktop";
};

const loadYousefGptCountry = async () => {
  if (countryLookupPromise) return countryLookupPromise;

  countryLookupPromise = (async () => {
    try {
      const response = await fetch("https://ipapi.co/json/", { cache: "no-store" });
      if (!response.ok) throw new Error("Country lookup failed");

      const data = await response.json();
      const countryName = data.country_name || "";
      const countryCode = data.country_code ? ` (${data.country_code})` : "";
      yousefGptCountry = countryName ? `${countryName}${countryCode}` : data.country || "";
    } catch (error) {
      yousefGptCountry = "Unavailable";
    }
  })();

  return countryLookupPromise;
};

const hasDecorChatUsage = () => {
  return decorChatUsed;
};

const setDecorChatUsage = () => {
  decorChatUsed = true;
};

const submitYousefGptMessage = async (message) => {
  const formData = new URLSearchParams();
  const createdAt = new Date().toISOString();
  const country = yousefGptCountry || "Pending";
  const deviceType = detectDeviceType();

  formData.append("form-name", "yousefgpt");
  formData.append("message", message);
  formData.append("page", window.location.href);
  formData.append("language", navigator.language || "");
  formData.append("country", country);
  formData.append("deviceType", deviceType);
  formData.append("userAgent", navigator.userAgent || "");
  formData.append("createdAt", createdAt);

  const response = await fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: formData.toString()
  });

  if (!response.ok) {
    throw new Error("YousefGPT submission failed");
  }
};

const appendDecorChatBubble = (container, text, type) => {
  const bubble = document.createElement("p");
  bubble.className = `decor-chat__bubble decor-chat__bubble--${type}`;
  bubble.textContent = text;
  container.appendChild(bubble);
  container.scrollTop = container.scrollHeight;
};

const initDecorChat = () => {
  const widget = document.querySelector("[data-chat-widget]");
  const toggle = document.querySelector("[data-chat-toggle]");
  const close = document.querySelector("[data-chat-close]");
  const panel = document.querySelector("[data-chat-panel]");
  const form = document.querySelector("[data-chat-form]");
  const input = document.querySelector("[data-chat-input]");
  const messages = document.querySelector("[data-chat-messages]");
  const pageInput = document.querySelector("[data-chat-page]");
  const languageInput = document.querySelector("[data-chat-language]");
  const countryInput = document.querySelector("[data-chat-country]");
  const deviceTypeInput = document.querySelector("[data-chat-device-type]");
  const userAgentInput = document.querySelector("[data-chat-user-agent]");
  const createdAtInput = document.querySelector("[data-chat-created-at]");

  if (!widget || !toggle || !panel || !form || !input || !messages) return;

  const setOpen = (isOpen) => {
    panel.hidden = !isOpen;
    toggle.setAttribute("aria-expanded", String(isOpen));
    if (isOpen) {
      loadYousefGptCountry();
      input.focus();
    }
  };

  toggle.addEventListener("click", () => setOpen(panel.hidden));
  close?.addEventListener("click", () => setOpen(false));

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !panel.hidden) {
      setOpen(false);
      toggle.focus();
    }
  });

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const message = input.value.trim();
    if (!message) return;

    appendDecorChatBubble(messages, message, "user");

    if (pageInput) pageInput.value = window.location.href;
    if (languageInput) languageInput.value = navigator.language || "";
    if (countryInput) countryInput.value = yousefGptCountry || "Pending";
    if (deviceTypeInput) deviceTypeInput.value = detectDeviceType();
    if (userAgentInput) userAgentInput.value = navigator.userAgent || "";
    if (createdAtInput) createdAtInput.value = new Date().toISOString();

    submitYousefGptMessage(message).catch(() => {
      // Netlify Forms receives this on the live site; localhost may reject POST.
    });

    input.value = "";

    if (hasDecorChatUsage()) {
      appendDecorChatBubble(
        messages,
        "Usage limit has been reached for now. Try again later.",
        "bot"
      );
      return;
    }

    setDecorChatUsage();
    const reply = decorChatReplies[Math.floor(Math.random() * decorChatReplies.length)];
    appendDecorChatBubble(messages, reply, "bot");
  });
};

initDecorChat();

const initPrivacyModal = () => {
  const modal = document.querySelector("[data-privacy-modal]");
  const openButtons = document.querySelectorAll("[data-privacy-open]");
  const closeButtons = document.querySelectorAll("[data-privacy-close]");
  const closeButton = modal?.querySelector("button[data-privacy-close]");
  let returnFocusNode = null;

  if (!modal || !openButtons.length) return;

  const setOpen = (isOpen) => {
    modal.hidden = !isOpen;
    document.body.classList.toggle("privacy-modal-open", isOpen);

    if (isOpen) {
      closeButton?.focus();
    } else if (returnFocusNode instanceof HTMLElement) {
      returnFocusNode.focus();
      returnFocusNode = null;
    }
  };

  openButtons.forEach((button) => {
    button.addEventListener("click", () => {
      returnFocusNode = button;
      setOpen(true);
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", () => setOpen(false));
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !modal.hidden) {
      setOpen(false);
    }
  });
};

initPrivacyModal();

// --- A quiet hello for anyone who opens the console. ------------------------
const consoleSignature = () => {
  const accent =
    "color:#79d9d0;font:600 13px/1.7 'IBM Plex Mono',ui-monospace,monospace";
  const faint =
    "color:#8a8a86;font:400 12px/1.7 'IBM Plex Mono',ui-monospace,monospace";
  // eslint-disable-next-line no-console
  console.log("%c0xyousef %c— Yousef Ali", accent, faint);
  // eslint-disable-next-line no-console
  console.log(
    "%ccommercial telecom · systems · history. hand-built, zero frameworks.\n" +
      "the portrait above is my face, sampled into drifting hex.\n" +
      "source: github.com/noble-yu/Intro   ·   say hi: contact@0xyousef.com",
    faint
  );
};

consoleSignature();
